import { useCallback } from 'react'

import { useUnit } from 'effector-react'

import { Page } from '@/components/layout/page/page.tsx'
import { DefaultPageSkeleton } from '@/components/ui/default-page-skeleton'
import {
  $isAiChattingEnabled,
  $isAiChattingInitializing,
  changeAiChSetting,
} from '@/models/ai-features/ai-chatting.ts'
import { $isCreatorProcessCompleted } from '@/models/creators.ts'
import { SettingsPageTitle } from '@/modules/creator-settings/SettingsPageTitle.tsx'

export const AICHAlpha = () => {
  const isCreatorProcessCompleted = useUnit($isCreatorProcessCompleted)
  const isEnabled = useUnit($isAiChattingEnabled)
  const isInitializing = useUnit($isAiChattingInitializing)

  const handleChangeAiChSetting = useCallback(() => {
    changeAiChSetting({ mode: false, state: !isEnabled })
  }, [isEnabled])

  if (!isCreatorProcessCompleted) {
    return <DefaultPageSkeleton />
  }

  return (
    <Page>
      <div>
        {isInitializing && (
          <div className="mb-4 w-full rounded-md border p-4 text-sm">
            The feature is currently initializing, this may take several minutes
          </div>
        )}
        <SettingsPageTitle
          title="AICH Alpha"
          description={
            <span className="flex items-center gap-2">
              AICH Alpha is an AI suggestion tool, that will help with chatting.
              Recommended to turn off the AI Translator when using AICH Alpha,
              to avoid problems.
            </span>
          }
          toggleName="Activate"
          enabled={isInitializing || isEnabled}
          disabled={isInitializing}
          onChange={handleChangeAiChSetting}
        />
      </div>
    </Page>
  )
}
